import templateUrl from 'emun.salesrep/inside-sales-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

class InsideSalesListController {
  constructor($scope) {
    const $ctrl = this;
    basicController($ctrl);
  }
  $onInit() {
    const $ctrl = this;
    $ctrl.query = $ctrl.container.query;
  }
  load() {
    const $ctrl = this;
    return $ctrl.query.load.apply($ctrl.query, arguments);
  }
}

export default {
  bindings: {
  },
  require: {
    container: '^insideSalesContainer'
  },
  controller: InsideSalesListController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
};